import PIETag, { ETagsColorType } from '@src/shared/components/PIETag';
import PIEText from '@src/shared/components/PIEText';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './DashboardDeliveryDataCourierTableList.module.scss';
import DashboardDeliveryDataCourierTableListItem from '../DashboardDeliveryDataCourierTableListItem';
import { PIEComponentUtil } from '@src/shared/components/PIEComponentUtil';
import { IStatisticsCouriers } from '../..';
import { useKeycloakUserState } from '@src/shared/context/keycloak-user';
import courierImage from '@assets/courier_detail_view_header.png';

interface componentProps {
  courierList: IStatisticsCouriers[];
}

const DashboardDeliveryDataCourierTableList = ({ courierList }: componentProps) => {
  const { t } = useTranslation();
  const { restaurant } = useKeycloakUserState();
  const cultureCode = `${restaurant?.country?.toLowerCase()}-${restaurant?.country?.toUpperCase()}`;
  if (courierList.length === 0) {
    return (
      <>
        <img
          src={courierImage}
          className={styles.DashboardDeliveryDataCourierTableListPlaceholderImage}
        />
        <PIEComponentUtil marginTop="var(--xds-spacing-d)" padding="var(--xds-spacing-b)">
          <PIEText
            text={t('deliverydata.COURIER_LIST_EMPTY_STATE_TITLE')}
            color="var(--xds-color-content-default)"
            size="var(--xds-font-size-20)"
            fontWeight="var(--xds-font-weight-bold)"
            align="center"
          />
          <PIEComponentUtil marginTop="var(--xds-spacing-b)">
            <PIEText
              text={t('deliverydata.COURIER_LIST_EMPTY_STATE_DESCRIPTION')}
              color="var(--xds-color-content-default)"
              size="var(--xds-font-size-16)"
              fontWeight="var(--xds-font-weight-regular)"
              align="center"
            />
          </PIEComponentUtil>
        </PIEComponentUtil>
      </>
    );
  }
  return (
    <>
      <>
        <div className={styles.DashboardDeliveryDataCourierTableListHeaderContainer}>
          <PIEText
            text={t('deliverydata.COURIER_LIST_HEADER_TITLE')}
            color="var(--xds-color-content-default)"
            size="var(--xds-font-size-16)"
            fontWeight="var(--xds-font-weight-bold)"
          />
          <PIETag mode={ETagsColorType.Neutral}>{t('deliverydata.COURIER_LIST_HEADER_TAG')}</PIETag>
        </div>
        <PIEComponentUtil marginTop="var(--xds-spacing-d)" marginBottom="var(--xds-spacing-d)">
          {courierList.map((courier, index) => {
            return (
              <PIEComponentUtil marginBottom="var(--xds-spacing-d)" key={index}>
                <DashboardDeliveryDataCourierTableListItem
                  courierName={courier.firstName + ' ' + courier.lastName}
                  deliveredCount={courier.trackedOrders}
                  cashCollected={Intl.NumberFormat(cultureCode, {
                    style: 'currency',
                    currency: courier.currencyCode,
                  }).format(courier.cashToCollect)}
                  tipCollected={Intl.NumberFormat(cultureCode, {
                    style: 'currency',
                    currency: courier.currencyCode,
                  }).format(courier.tipsAmount)}
                  isMostDelivered={courier.topDeliveryBadge}
                  courierType={courier.type}
                />
              </PIEComponentUtil>
            );
          })}
        </PIEComponentUtil>
      </>
    </>
  );
};

export default DashboardDeliveryDataCourierTableList;
